export default () => (JSON.parse(localStorage.getItem('user')).user.isStaff ? 'admin' : 'resident');
